import React from 'react';
import './UpdateBanner.scss';

export default function UpdateBanner({ visible, onReload }) {
    if (!visible) {
        return null;
    }

    return (
        <div className="update-banner" role="status" aria-live="polite">
            <span className="update-banner__text">
                En ny versjon av portalen er tilgjengelig.
            </span>
            <button
                type="button"
                className="update-banner__button"
                onClick={onReload}
            >
                Oppdater nå
            </button>
        </div>
    );
}
